import { all, put, takeEvery, select } from 'redux-saga/effects';
import { path, isEmpty } from 'ramda';
import { setWorksheetMassListSelectedStage } from 'actions/worksheetMassActions';

import { SET_WORKSHEET_MASS_LIST_SELECTED } from 'constants/actionTypes';

export default function* addWorksheetStage() {
    yield all([
        takeEvery(SET_WORKSHEET_MASS_LIST_SELECTED, function* setStageKey(action) {
            const selectedStageKey = path(['attrs', 'item', 'stageKey'], action);
            const selected = yield select(path(['table', 'worksheetMass', 'selected']));
            const stageKey = !isEmpty(selected) ? selectedStageKey : null;
            yield put(setWorksheetMassListSelectedStage(stageKey));
        })
    ]);
}
